var map = {
	"./bg1.jpg": 147,
	"./bg2.jpg": 148,
	"./bg3.jpg": 149,
	"./bg4.jpg": 150,
	"./bg5.jpg": 151,
	"./bg6.jpg": 152,
	"./bgno.jpg": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;